export default __webpack_public_path__ + "static/media/dsdelivery.aa6e4f39.png";